import React, { Ref, useCallback, useEffect, useMemo, useState } from "react"
import {
  Link,
  Outlet,
  useLocation,
  useParams,
  useNavigate,
} from "react-router-dom"
import { useContextSelector } from "use-context-selector"
import { Header, Sidebar, Button, IMenuElement } from "@unlimint/admin-ui-kit"
import { isEmpty } from "lodash"

import { menuConfig } from "view/layouts/menu.config"
import { AlertEvent } from "view/components/Alert"

import { AppContext } from "domain/application/AppContext"
import { appSelectors } from "domain/application/selectors"
import { keycloakService } from "domain/identity/KeycloakService"

import UnlimitCryptoLogo from "assets/images/unlimit-crypto.svg"
import UnlimitCryptoMiniLogo from "assets/images/unlimit-crypto-mini.svg"

import * as S from "./styled"
import { prepareMenuConfig } from "../MainLayout/utils"
import { pathsWithoutIndexComponent } from "../MainLayout/pathsWithoutIndexComponent"

const LinkRef = React.forwardRef((props: IMenuElement, ref) => (
  <Link ref={ref as Ref<HTMLAnchorElement>} to={props?.to} {...props} />
))

const Logo = <S.LogoIcon src={UnlimitCryptoLogo} alt="logo" />

const MinLogo = <S.LogoMiniIcon src={UnlimitCryptoMiniLogo} alt="logo" />

const LogOut = () => (
  <Button size="small" variant="outlined" onClick={keycloakService.logout}>
    Log out
  </Button>
)

export const CustomizationLayout = () => {
  const [open, setOpen] = useState(true)
  const [showBack, setShowBack] = useState(false)

  const isReady = useContextSelector(AppContext, appSelectors.isReady)
  const title = useContextSelector(AppContext, appSelectors.title)

  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()

  useEffect(() => {
    setShowBack(!isEmpty(params))
  }, [params])

  const onBack = useCallback(() => {
    const hasExcludedPath = pathsWithoutIndexComponent.some((excludedPath) =>
      location?.pathname.includes(excludedPath)
    )

    let to = ".."
    if (hasExcludedPath) {
      to = `${to}/..`
    }

    navigate(to, { relative: "path" })
  }, [navigate, location?.pathname])

  const currentConfig = useMemo(() => {
    const config = menuConfig()
    const path = location?.pathname?.split("/")?.[1]
    const childPath = location?.pathname?.split("/")?.[2]

    return prepareMenuConfig(config, path, childPath)
  }, [location.pathname])

  return (
    <S.Wrapper>
      <S.LeftBlock>
        <Sidebar
          config={currentConfig}
          menuItemComponent={LinkRef}
          open={open}
          setOpen={setOpen}
          logo={Logo}
          logoMin={MinLogo}
        />
      </S.LeftBlock>
      <S.RightBlock>
        <Header
          title={title}
          open={open}
          userMenu={<LogOut />}
          // onBack={showBack && onBack}
        />
        <S.Content>{isReady && <Outlet />}</S.Content>
      </S.RightBlock>
      <AlertEvent />
    </S.Wrapper>
  )
}
